module.exports = __webpack_public_path__ + "img/quato1.f82106b5.png";